var createReactClass = require('create-react-class');
import React from 'react';
import ChecklistItem from './ChecklistItem';


const BlockOrDesk = createReactClass({
  getInitialState: function () {
    return {
      disabled: '',
      block: 0,
      desk: 0
    }
  },

  componentDidMount: function() {
    var block = 0
    var desk = 0
    var pass = 0
    var items = this.props.blockOrDeskItems
    for(var index in items) {
      if(!items[index] && items[index] !== undefined) {
        if(index >= 0 && index < 4) {
          desk++
        } else {
          block++
        }
      } else {
        pass++
      }
    }
    var disabled = (pass == 9 || (pass == 8 && this.props.isOriginalArticle)) ? '' : ' disabled'
    this.setState({disabled: disabled, block: block, desk: desk})
  },

  buttonDisable: function(index, status) {
    var disabled;
    var disabled = (document.querySelectorAll('.pass').length == 9 || (document.querySelectorAll('.pass').length == 8 && this.props.isOriginalArticle))? '' : ' disabled'
    this.setState({disabled: disabled}, function() {
      this.props.blockOrDeskItemsAdd(index, status)
    });
  },

  handleCheck: function(score, type) {
    var newScore = this.state[type] + parseInt(score)
    this.setState({[type]: newScore})
  },

  renderRecommendedAction: function() {
    if(this.state.block > 0 && this.state.desk > 0) {
      return (
        <h4 className="recommend">Recommended action: Block or Desk reject</h4>
      ) 
    } else if(this.state.block > 0) {
      return (
        <h4 className="recommend">Recommended action: Block</h4>
      )
    } else if(this.state.desk > 0) {
      return (
        <h4 className="recommend">Recommended action: Desk reject</h4>
      )
    } else {
      return (
        <h4 className="recommend">Recommended action: Proceed</h4>
      )
    }
  },

  renderFirstChecklistItem: function() {
    if(!this.props.isOriginalArticle) {
      return (
        <ChecklistItem 
          title={"Issues with study relevance, design, results, etc*"}
          buttonDisable={this.buttonDisable}
          type={'desk'}
          handleCheck={this.handleCheck}
          index={0}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
      )
    }
  },

  handleSelectAll: function(deferType) {
    document.querySelectorAll('.fa-check-circle').forEach(function(node) {
      if(node.getAttribute('name') === deferType) {
        if(!node.classList.contains('pass')) {
          setTimeout(function() {
            node.click()
          }, 1)
        }
      }
    })
  },

  renderSelectAll: function(deferType) {
    return(
      <div className="checklist-item row">
        <div className="large-3 large-offset-8 columns end">
          <div className="select-all">
            <a className="button tiny success" onClick={() => this.handleSelectAll(deferType)}>Select All</a> 
          </div>
        </div>
      </div>
    )  
  },

  renderDeskChecklist: function() {
    return (
      <div className="checklist">
        {this.renderSelectAll('desk')}
        {this.renderFirstChecklistItem()}
        <ChecklistItem 
          title={"Topic not acceptable for Cureus* (permanent)"}
          buttonDisable={this.buttonDisable}
          type={'desk'}
          handleCheck={this.handleCheck}
          index={1}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"Submitted as incorrect article type (new submission is okay)"}
          buttonDisable={this.buttonDisable}
          type={'desk'}
          handleCheck={this.handleCheck}
          index={2}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"Other issues"}
          buttonDisable={this.buttonDisable}
          type={'desk'}
          handleCheck={this.handleCheck}
          index={3}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
      </div>
    )
  },

  renderBlockChecklist: function() {
    return (
      <div className="checklist">
        {this.renderSelectAll('block')}
        <ChecklistItem 
          title={"New submission after deferral"}
          buttonDisable={this.buttonDisable}
          type={'block'}
          handleCheck={this.handleCheck}
          index={4}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"New submission after desk rejection or block"}
          buttonDisable={this.buttonDisable}
          type={'block'}
          handleCheck={this.handleCheck}
          index={5}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"Fraudulent peer reviewers (fake or same as authors) **"}
          buttonDisable={this.buttonDisable}
          type={'block'}
          handleCheck={this.handleCheck}
          index={6}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"Plagiarism (as seen in iThenticate report) **"}
          buttonDisable={this.buttonDisable}
          type={'block'}
          handleCheck={this.handleCheck}
          index={7}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />
        <ChecklistItem 
          title={"Other issues"}
          buttonDisable={this.buttonDisable}
          type={'block'}
          handleCheck={this.handleCheck}
          index={8}
          blockOrDeskItems={this.props.blockOrDeskItems}
        />        
      </div>
    )
  },

  renderGoBack: function() {
    if(this.props.isOriginalArticle) {
      return (
        <a className={"button secondary"} name="back" onClick={this.props.handleNext}>Go back</a>
      )
    }
  },

  render: function() {
    return (
        <div className="modal-body">
          <div className='modal-close'>
            <a href='#' className='cancel-modal'>
              <img src="https://gallery.cureusjournals.com/collection/close_x.png"/>
            </a>
          </div>
          <div className="modal-content">
            <h3 className="reg">Should this be blocked or desk rejected?</h3>
            {this.props.renderIthenticates()}
            <h4>Desk reject if:</h4>
            {this.renderDeskChecklist()}
            <p><emp>*Refer to Submissions Editing guide for details.</emp></p>
            <h4>Block if:</h4>
            {this.renderBlockChecklist()}
          </div>
          {this.renderRecommendedAction()}
          <div className="modal-footer">
            {this.renderGoBack()}
            <a className={"button special " + (this.state.desk > 0 ? '' : 'disabled')} name="desk" onClick={this.props.handleNext}>Desk Reject</a>
            <a className={"button alert " + (this.state.block > 0 ? '' : 'disabled')} name="block" onClick={this.props.handleNext}>Block</a>
            <a className={"button primary " + this.state.disabled} name="next" onClick={this.props.handleNext}>Next</a>
          </div>
        </div>
    )
  }
})

export default BlockOrDesk;